module.exports = __webpack_public_path__ + "static/media/main-logo.b192ab51.png";